module.exports = __webpack_public_path__ + "static/offensive-shield-logo-c542cbbe2541b57328b76bca00232b9c.png";